import { Options } from '@sheerid/jslib';
import { messagesEN } from './lib/intl/en-US';
import { messagesDE } from './lib/intl/de';
import { messagesFR } from './lib/intl/fr';
import { messagesGB } from './lib/intl/en-GB';
import { messagesIT } from './lib/intl/it';
import { messagesES } from './lib/intl/es';
import { messagesNL } from './lib/intl/nl';

import { RecursivePartial } from './lib/types/types';

export const programId = '61294d86a92ceb246f0395e4';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
        'en-GB': messagesGB,
        de: messagesDE,
        fr: messagesFR,
        it: messagesIT,
        es: messagesES,
        nl: messagesNL,
    },
};
